import _ from 'lodash';

// 多语言id
export const localeMap = [
  {
    value: 3,
    label: '简体中文'
  },
  {
    value: 2,
    label: '繁體中文'
  },
  {
    value: 1,
    label: 'English'
  },
  {
    value: 4,
    label: 'Bahasa Indonesia'
  }
];

// 多语言key
export const localeKeys = ['cn', 'hk', 'en', 'id'];

// 多语言key转value
export const localeKeyToValueMap = {
  cn: 'zh-CN',
  hk: 'zh-HK',
  en: 'en',
  id: 'id-ID'
};

// 多语言key转value（腾讯验证插件使用）
export const localeKeyToValueTencentMap = {
  cn: 'zh-cn',
  hk: 'zh-hk',
  en: 'en',
  id: 'id'
};

// 多语言value转key
export const localeValueToKeyMap = {
  'zh-CN': 'cn',
  'zh-HK': 'hk',
  'zh-TW': 'hk',
  'en-US': 'en',
  en: 'en',
  'id-ID': 'id'
};

const initSpace = (value, key = window.VM.$i18n.locale) => {
  const space = _.includes(['en', 'id'], key) ? ' ' : '';
  return `${value[0]}${space}${value[1]}`;
};
// 本地多语言转对应值
export const localeKeyToValue = (key, number = '') => {
  const value = {
    value: initSpace([window.VM.$t(key), number]),
    i18nValue: {}
  };
  _.forEach(localeKeys, (v) => {
    value.i18nValue[v] = initSpace([window.VM.$t(key, v), number], v);
  });
  return value;
};

// 返回用于显示的多语言值
export const getLocaleValue = (data, locale = window.VM.$i18n.locale) => {
  if (!data || typeof data === 'string') {
    return data;
  }
  return data.i18nValue[locale] || data.value;
};
